module.exports = __webpack_public_path__ + "static/media/country_dj.89332d0e.webp";